/**
 * A global namespace for `blur` event.
 */
const blurEvent = "blur";
export default blurEvent;
